import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopyDashboard} from '../../../apis/analysis/getCopyDashboard'
import {getActiveApi} from '../../../apis/analysis/getActiveApi'

export const useQueryActiveApi = (limit: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getActiveApi(limit),
        queryFn: async () => {
            const {data} = await getActiveApi(limit)
            return data
        },
    })

    return {data, refetch}
}
